$(document).ready(function () {
  const $slick = $('.pilates-slider-wrapper .slick');
  const BREAKPOINT = 1024;

  $slick.on('init', function (e, slick) {
    const container = getContainer(slick);
    initTitles(container, slick.currentSlide);
  });

  $slick.on('beforeChange', function (e, slick, curr, next) {
    const container = getContainer(slick);
    const direction = isNext(slick, curr, next);
    handleTitleTransition(direction, next, container);
  });

  function initSlider() {
    if (window.innerWidth >= BREAKPOINT) return;
    if ($slick.hasClass('slick-initialized')) return;

    $slick.find('.slick-item:hidden').remove();

    $slick.slick({
      centerMode: true,
      centerPadding: '105px',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      arrows: false,
      variableWidth: true
    });

    $slick.on('afterChange', function (event, slick, currentSlide) {
      calculateSlickScrollPercentage(slick);
    });
  }

  function destroySlider() {
    if (!$slick.hasClass('slick-initialized')) return;
    $slick.slick('unslick');
  }

  function handleResize() {
    if (window.innerWidth < BREAKPOINT) {
      initSlider();
    } else {
      destroySlider();
    }
  }

  initSlider();
  $(window).on('resize', handleResize);

  function getContainer(slick) {
    return slick.$slider.closest('.all-in-one')[0] || document;
  }

  function isNext(slick, curr, next) {
    const last = slick.slideCount - 1;
    if (next === 0 && curr === last) return true;
    if (next > curr) return true;
    return false;
  }

  function initTitles(container, index) {
    const titles = container.querySelectorAll(
      '.body-scan_wrapper_header__title'
    );
    titles.forEach(el => {
      const i = Number(el.dataset.index);
      el.classList.remove('next', 'prev', 'active', 'hidden');
      if (i === index) el.classList.add('active');
      else el.classList.add('hidden');
    });
  }

  function handleTitleTransition(direction, nextIndex, container) {
    const addedClass = direction ? 'next' : 'prev';
    const removedClass = direction ? 'prev' : 'next';
    const activeSlideTitle = container.querySelector(
      '.body-scan_wrapper_header__title.active'
    );
    if (!activeSlideTitle) {
      initTitles(container, nextIndex);
      return;
    }
    if (Number(activeSlideTitle.dataset.index) !== nextIndex) {
      activeSlideTitle.dispatchEvent(new CustomEvent('transitionend'));
      activeSlideTitle.classList.add(removedClass);
      activeSlideTitle.classList.remove('active');
      if (window.innerWidth >= 1280) {
        activeSlideTitle.classList.add('hidden');
        activeSlideTitle.classList.remove(removedClass);
      } else {
        activeSlideTitle.addEventListener(
          'transitionend',
          () => {
            activeSlideTitle.classList.add('hidden');
            activeSlideTitle.classList.remove(removedClass);
          },
          { once: true }
        );
      }

      const neededSlideTitle = container.querySelector(
        `.body-scan_wrapper_header__title[data-index="${nextIndex}"]`
      );
      if (!neededSlideTitle) return;
      neededSlideTitle.dispatchEvent(new CustomEvent('transitionend'));
      neededSlideTitle.classList.add(addedClass);
      neededSlideTitle.classList.remove('hidden');
      setTimeout(() => {
        neededSlideTitle.classList.add('active');
      }, 10);
      if (window.innerWidth >= 1280) {
        neededSlideTitle.classList.remove(addedClass);
      } else {
        neededSlideTitle.addEventListener(
          'transitionend',
          () => {
            neededSlideTitle.classList.remove(addedClass);
          },
          { once: true }
        );
      }
    }
  }
});
